import React from "react";
import { useSelector } from "react-redux";

const Modal = ({ isOpen, onClose, children, width }) => {
  const { dir} = useSelector((state) => state.language);
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-[#1e1e1eb7] overflow-auto py-4">
      <div
        className={`relative mx-2 ${width ? width : "w-[400px]"} rounded-lg bg-gray-800 p-4 shadow-1 transition-bg duration-300 border-dark-3 bg-gray-dark shadow-card`}
      >
        <button
          onClick={onClose}
          className={`absolute ${dir === "rtl" ? "left-2 " : "right-2"} top-2 text-2xl text-gray-600 hover:text-primary`}
        >
          &times;
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;